export default {"src":"/_next/static/media/ico5.6f73fcd5.svg","height":43,"width":35,"blurWidth":0,"blurHeight":0};